module.exports = __webpack_public_path__ + "assets/img/banner-7.f4660e43.png";